import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Title } from 'react-head';
import { useSize } from 'ahooks';
import img from './img.png?url';

import * as Styled from './simple.styled';
import { getSize } from '/src/theme';

const SimpleLayout = ({ headTitle = 'PingCAP Account', title = 'TiDB', subtitle = 'SQL at Scale', children }) => {
  useEffect(() => {
    // react-head would not overwrite default title tag
    // see https://github.com/tizmagik/react-head/issues/83
    // why here? if we remove title tag early than react-head injected it, the title will change to the host shortly.
    const defaultTitle = document.getElementById('default-title');
    if (defaultTitle) defaultTitle.parentNode.removeChild(defaultTitle);
  }, []);

  const containerRef = useRef();
  const { width } = useSize(containerRef) ?? {};

  const size = useMemo(() => getSize(width), [width]);

  return (
    <>
      <Title>{headTitle}</Title>
      <Styled.Container ref={containerRef} $size={size}>
        <Styled.Main $size={size}>
          <div>
            <Styled.Logo />
            <Styled.Title>{title}</Styled.Title>
            <Styled.SubTitle>{subtitle}</Styled.SubTitle>
            {children}
          </div>
        </Styled.Main>
        <Styled.Side $size={size}>
          <div>
            <img src={img} alt='TiDB' width={240} />
            <p className='headline'>
              欢迎加入 TiDB 大家庭！
            </p>
            <h3>
              为什么选择 TiDB？
            </h3>
            <h4>
              🔁 原生分布式一体化架构
            </h4>
            <p>
              事务与分析融合（Real-Time HTAP），一套架构同时承载海量交易与实时分析
            </p>
            <h4>
              🌐 弹性扩展，业务无忧
            </h4>
            <p>
              数据规模从 GB 到 PB 平滑扩容，满足企业从初创到超大规模发展需求
            </p>
            <h4>
              🛡️ 金融级高可用与安全
            </h4>
            <p>
              同城/异地容灾方案（RPO=0，RTO&lt;30s），100% 自研代码，自主可控
            </p>
            <h4>
              ⚡ 极致兼容，无缝迁移
            </h4>
            <p>
              强兼容 MySQL 生态，无需分库分表，支持 Oracle 全链路迁移
            </p>
            <h4>
              🤖 智能运维与多模融合
            </h4>
            <p>
              AI 驱动向量检索、多模型支持，多监控平台可管控集群，降低开发成本
            </p>
          </div>
        </Styled.Side>
      </Styled.Container>
    </>
  );
};

SimpleLayout.displayName = 'SimpleLayout';
SimpleLayout.propTypes = {
  headTitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.element,
};

export default SimpleLayout;
